
export function setLocation(state, data) {
  state.location = data
}

export function setWorkOrderInvoice(state, data) {
    state.workOrderInvoiceId = data
}



